export default __webpack_public_path__ + "static/media/tdhqn.8762d981.png";